// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__sI89v","close":"Modal_close__9MpHR"};